












import { Component, Prop, Vue } from 'vue-property-decorator';
import VueSmartSliderMark from './VueSmartSliderMark.vue';
import { SliderMark } from './types/SliderTypes';

@Component({ components: { VueSmartSliderMark } })
export default class VueSmartSliderMarks extends Vue {
  name = 'VueSmartSliderMarks';

  @Prop({ required: false, default: () => [], type: Array }) readonly propMarks!: Array<SliderMark>;

  @Prop({ required: false, type: Number, default: 0 }) readonly propWidth!: number;

  @Prop({ required: false, type: Number, default: 100 }) readonly propMax!: number;
}
